import { AppRouterService } from "core/routes/app-router.service";
import { PathEnum } from "core/routes/path.enum";
import { Navigate, Route, Routes } from "react-router-dom";
import ProcessoTerminato from "./processo-terminato";
import RequirementsPage from "./requirements";
import StartPage from "./start-page";
import FirstStepPage from "./step-1";
import CercaImpresa from "./step-1/cerca-impresa";
import CodiceAttivazione from "./step-1/codice-attivazione";
import CreazioneProfilo from "./step-1/creazione-profilo";
import SecondStepPage from "./step-2";
import ThirdStepPage from "./step-3";
import IdentificazioneLegaleRappresentante from "./step-3/dettagli-legale-rappresentante";
import IdentificazioneTitolareEffettivo from "./step-3/dettagli-titolare-effettivo";
import SceltaLegaleRappresentante from "./step-3/scelta-legale-rappresentante";
import SceltaTitolareEffettivo from "./step-3/scelta-titolare-effettivo";
import FourthStepPage from "./step-4";
import FifthStepPage from "./step-5";
import SixStepPage from "./step-6";
import SeventhStepPage from "./step-7";

const OnBoardingRouter: React.FC = () => {
	return (
		<Routes>
			<Route path="/" element={<Navigate to={PathEnum.start} />} />

			<Route path={AppRouterService.get(PathEnum.start)} element={<StartPage />} />
			<Route path={AppRouterService.get(PathEnum.requirements)} element={<RequirementsPage />} />

			<Route path={AppRouterService.get(PathEnum.step1)} element={<FirstStepPage />}>
				<Route path="" element={<Navigate to={PathEnum.creazioneProfilo} replace />} />

				<Route path={PathEnum.creazioneProfilo} element={<CreazioneProfilo />} />
				<Route path={PathEnum.codiceAttivazione} element={<CodiceAttivazione />} />
				<Route path={PathEnum.cercaImpresa} element={<CercaImpresa />} />
			</Route>

			<Route path={`${AppRouterService.get(PathEnum.step2)}/*`} element={<SecondStepPage />} />

			<Route path={AppRouterService.get(PathEnum.step3)} element={<ThirdStepPage />}>
				<Route path="" element={<Navigate to={PathEnum.raccontaciDiTe} replace />} />

				<Route path={PathEnum.raccontaciDiTe} element={<SceltaLegaleRappresentante />} />
				<Route
					path={`${PathEnum.identificazioneLegaleRappresentante}/*`}
					element={<IdentificazioneLegaleRappresentante />}
				/>
				<Route path={PathEnum.sceltaTitolareEffettivo} element={<SceltaTitolareEffettivo />} />
				<Route
					path={`${PathEnum.identificazioneTitolareEffettivo}/*`}
					element={<IdentificazioneTitolareEffettivo />}
				/>
			</Route>

			<Route path={`/${PathEnum.step4}/*`} element={<FourthStepPage />} />

			<Route path={`/${PathEnum.step5}`} element={<FifthStepPage />} />
			<Route path={`/${PathEnum.step6}`} element={<SixStepPage />} />
			<Route path={`/${PathEnum.step7}`} element={<SeventhStepPage />} />

			<Route path={`/${PathEnum.processoTerminato}`} element={<ProcessoTerminato />} />
		</Routes>
	);
};
export default OnBoardingRouter;
